import type { CSSProperties } from "react";
import React from "react";

import classnames from "classnames/bind";

import { DotSpinner } from "../../../basic/spinners";
import { Popup } from "../Popup";

import styles from "./BasicPopup.module.scss";

const cx = classnames.bind(styles);

export function BasicPopup({
    onClose, //
    isLoading,
    style,
    children,
}: Props) {
    return (
        <Popup onClose={onClose}>
            <div className={cx("basic-popup")}>
                {isLoading === true ? (
                    <div>
                        <DotSpinner />
                    </div>
                ) : (
                    <div
                        style={style}
                        className={cx("popup")}
                    >
                        {children}
                    </div>
                )}
            </div>
        </Popup>
    );
}

interface Props extends ChildrenProps {
    isLoading?: boolean;
    style?: CSSProperties;
    onClose: () => void;
}
